const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user assessments list directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('userAssessmentsList', ['Application', 'UserAssessments', 'AccessHelper', '$translate', function (Application, UserAssessments, AccessHelper, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      assessment: '=',
      usersOverlay: '=',
      activeUserAssessment: '=',
      reset: '=',
      watch: '@'
    },
    template: require('../../../templates/directives/assessments/user-assessments-list.html'),
    controller: ['$scope', function ($scope) {
        var self = this;
        self.translations = {};

        self.allowance = {
          reset: AccessHelper.isAllowed(['admin', 'content', 'assessment_reset'], null, ['admin']),
        };

        self.goToContextLink = function(context) {
        let type = context.context_type.toLowerCase();
        if (type !== 'track') {
          type += 's';
        }
        return ('#/host/' + type + '/' + context.context._id);
      }

        self.info = {
          userAssessments: [],
          per_page: 15,
          loading: false,
          searching: false,
          sortName: 'createdAt',
          sortOrder: -1,
          query: {},
          selectionDirectory: {},
          allowedSubmissions: 1,
          onData: function(data) {
            self.navigation.noNext = false;
            if (!data || !data.length) {
              self.navigation.noNext = true;
              self.info.userAssessments = [];
              return;
            }

            self.info.userAssessments = data;
            if (data.length < self.info.per_page) {
              noNext = true;
            }
          },
          progress: function(item) {
            if (item.passed) {
              return 'green check';
            }
            if (item.awaiting_manual_grade) {
              return 'clock outline';
            }
            if (item.scores && item.scores.length >= self.info.allowedSubmissions) {
              return 'red close';
            }
            return 'load';
          },
          getRecordings: function(ua) {
            var recordings = 0;
            var question = $scope.assessment.questions && $scope.assessment.questions[0] && $scope.assessment.questions[0].id;

            if (!ua || !ua.scores || !ua.scores.length || !question) {
              return recordings;
            }
            ua.scores.forEach(function(item) {
              var count = item.user_responses && item.user_responses[question] && item.user_responses[question].length || 0;
              recordings += count;
            });
            return recordings;
          }
        };

        self.editMenu = {
          visible: false,
          activeId: null,
          closeHandler: function(){
            self.editMenu.visible = false;
            self.editMenu.activeId = null;
          },
          clickHandler: function(i){
            if (self.editMenu.visible) {
              if (self.editMenu.activeId === i) {
                self.editMenu.visible = false;
                self.editMenu.activeId = null;
              } else {
                self.editMenu.activeId = i;
              }
            } else {
              self.editMenu.activeId = i;
              self.editMenu.visible = true;
            }
          }
        };

        self.userAssessment = {
          show: false,
          active: null,
          onClick: function(item) {
            if (!item || !item._id) {
              return;
            }
            $scope.activeUserAssessment = item._id;
          }
        };

        var getStandardQuery = function(){
          return {
            fields: '_id,company,user,assessment,highest_graded_percentage,awaiting_manual_grade,passed,date_passed,content,content_type,createdAt,updatedAt,scores,contexts',
            page: 1,
            per_page: self.info.per_page,
            'user-populate': 'first_name,last_name,full_name,email,linked_departments,linked_locations',
            'user.linked_departments-populate': 'name',
            'user.linked_locations-populate': 'name',
            'scores-populate': 'user_responses',
            assessment: $scope.assessment && $scope.assessment._id,
            sort: `${self.info.sortName},${self.info.sortOrder}`
          };
        };

        self.initialize = function () {
          self.info.userAssessments = [];
          self.info.per_page = 15;
          self.info.loading = false;
          self.info.searching = false;
          self.info.query = getStandardQuery();
          self.info.searchQuery = {};
          self.info.selectionDirectory = {};
          self.info.allowedSubmissions = 1;
          self.info.initialized = true;
          self.userAssessment.show = false;
          self.userAssessment.active = null;
          self.navigation.noNext = false;
          if ($scope.assessment && $scope.assessment.allow_retake && $scope.assessment.number_of_retakes) {
            self.info.allowedSubmissions += $scope.assessment.number_of_retakes;
          }
          self.load();
        };

        self.load = function () {
          if (!$scope.assessment || !$scope.assessment._id) {
            // error for no assessment id
            return;
          }
          self.info.loading = true;
          UserAssessments.find(self.info.query).$promise
          .then(function (userAssessments) {
            self.info.onData(userAssessments);
            self.info.loading = false;
          }).catch(function (error) {
            self.info.loading = false;
            console.log('Error getting user assessments:', error);
          });
        };

        self.reset = {
          show: false,
          loading: false,
          current: null,
          confirmation: '',
          select: function(ua) {
            self.reset.current = ua;
            self.reset.show = true;
            self.reset.confirmation = '';
          },
          cancel: function() {
            self.reset.show = false;
            self.reset.current = false;
            self.reset.loading = false;
            self.reset.confirmation = '';
          },
          submit: function() {
            if (self.reset.confirmation !== 'RESET') {
              return;
            }

            UserAssessments.reset({subresource: self.reset.current._id}, null).$promise
            .then(function(results) {
              $scope.reset = true;
              self.reset.cancel();
              self.initialize();
              Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations.assessment.manualReset.completed});
            }).catch(function(error) {
              self.reset.cancel();
              Application.messaging.addMessage({type: 'error', text: self.translations.assessment.manualReset.error, duration: 5});
              return;
            })
          }
        };

        self.navigation = {
          noNext: false,
          placeholder: self.translations['userAssessmentsList.search_by_user'],
          previous: function () {
            if (self.info.query.page === 1) {
              return;
            }
            self.info.query.page--;
            self.search.searchLoad();
          },
          next: function () {
            if (self.info.userAssessments.length !== self.info.per_page || self.navigation.noNext) {
              return;
            }
            self.info.query.page++;
            self.search.searchLoad();
          }
        };

        self.search = {
          onQuery: async function(query_arguments) {
            self.info.searching = false;
            self.info.query = getStandardQuery();
            self.info.searchQuery = {};

            if (query_arguments && typeof query_arguments === 'object' && Object.keys(query_arguments).length) {
              self.info.searching = true;
              for (const key in query_arguments) {
                if (query_arguments.privacy_locations) {
                  self.info.searchQuery.linked_locations = query_arguments.privacy_locations;
                }
                if (query_arguments.privacy_departments) {
                  self.info.searchQuery.linked_departments = query_arguments.privacy_departments;
                }
                if (query_arguments.privacy_teams) {
                  self.info.searchQuery.linked_teams = query_arguments.privacy_teams;
                }
                if (query_arguments.privacy_org_levels) {
                  self.info.searchQuery.linked_org_level = query_arguments.privacy_org_levels;
                }
                if (query_arguments.privacy_grades) {
                  self.info.searchQuery.linked_grade = query_arguments.privacy_grades;
                }
                if (query_arguments.groups) {
                  self.info.searchQuery.groups = query_arguments.groups;
                }

                if (query_arguments['$or']) {
                  self.info.searchQuery['$or'] = query_arguments['$or'];
                }
              }
            }
            self.search.searchLoad();
          },
          searchLoad: function() {
            if (Object.keys(self.info.searchQuery).length === 0) {
              // assessment search-users endpoint return bad results if no user query passed in so use the "find" endpoint here instead
              // should really just all be updated to go through the "find" endpoint when this moves to react
              self.load();
            } else {
              self.info.loading = true;
              UserAssessments.searchUsers({subname: $scope.assessment._id}, {
                  reply: 'userAssessments',
                  usersQuery: self.info.searchQuery,
                userAssessmentsQuery: self.info.query
              }).$promise
                  .then(function (userAssessments) {
                  self.info.onData(userAssessments);
                  self.info.loading = false;
                  }).catch(function (error) {
                  // handle error with messaging
                  self.loading = false;
                  console.log('error in loading UserAssessments: ', error);
                });
            }
          }
        };

        self.selections = {
          select: function (item) {
            var id = item.user._id;
            if ($scope.usersOverlay[id]) {
              delete $scope.usersOverlay[id];
              delete self.info.selectionDirectory[id];
              return;
            }

            self.info.selectionDirectory[id] = item.user;
            $scope.usersOverlay[id] = item.user;
          },
          isChecked: function(item) {
            if (!item || !item.user || !item.user._id) {
              return false;
            }
            return $scope.usersOverlay[item.user._id] ? true : false;
          }
        };
        if ($scope.assessment && $scope.assessment._id) {
          self.initialize();
        }

        if ($scope.watch) {
          $scope.$watch('assessment', function(newVal, oldVal) {
            if (!newVal || (newVal && !newVal._id)) {
              return;
            }
            if (!oldVal || !oldVal._id || (newVal._id !== oldVal._id)) {
              self.initialize();
            }
          }, true);
        }

        $translate([
          'userAssessmentsList.search_by_user',
          'assessment.manualReset.completed',
          'assessment.manualReset.error'
        ]).then(function (translations) {
          self.translations = translations;
        });

      }],
    controllerAs: 'uaList'
  };
}]);